import _ from 'lodash';
import { sanitizeSeo } from '../utils';
import { GENERAL_SCHEMA } from '../constants';

export const shouldFormatSeo = (seo) => seo && !_.isEmpty(seo.schemaMarkup);

export const formatSeo = (seo) => {
    const { schemaMarkup } = seo;

    const formattedSeo = {
        '@context': GENERAL_SCHEMA,
        '@type': schemaMarkup.type,
        name: schemaMarkup.gigTitle,
        image: schemaMarkup.gigImage
    };

    const gigRatings = schemaMarkup.gigRatings,
        gigOffers = schemaMarkup.gigOffers;

    if (gigRatings) {
        formattedSeo.aggregateRating = {
            '@type': gigRatings.type,
            ratingValue: gigRatings.value,
            reviewCount: gigRatings.count,
            bestRating: gigRatings.best,
            worstRating: gigRatings.worst
        };
    }

    if (gigOffers) {
        formattedSeo.offers = {
            '@type': gigOffers.type,
            price: gigOffers.price,
            lowPrice: gigOffers.lowPrice,
            highPrice: gigOffers.highPrice,
            priceCurrency: gigOffers.currency,
            availability: `${GENERAL_SCHEMA}#{gig_offers['availability']}`
        };
    }

    return sanitizeSeo(formattedSeo);
};
